export enum FileType {
    PhysicianCharges = 'physician-charges',
    AnesthesiaCharges = 'anesthesia-charges',
    HospitalCharges = 'hospital-charges',
    HospitalW9Form = 'hospital-w9-form'
}